import dayjs from "dayjs";
import api from "@/api";
import store from "@/store";
import router from "@/router/router";
import VueCookies from "vue-cookies";
import { Notification } from "element-ui";

export default {
  // 複製文字
  copyText(e) {
    let text = e.target.innerText;
    navigator.clipboard
      .writeText(text)
      .then(() =>
        Notification({
          title: "成功",
          message: "複製成功",
          type: "success",
          duration: 2500,
        })
      )
      .catch(() =>
        Notification({
          title: "失敗",
          message: "複製失敗",
          type: "error",
          duration: 2500,
        })
      );
  },

  // 布林值格式
  booleanFormatter(element) {
    if (element === true) {
      return "是";
    } else if (element === false) {
      return "否";
    }
  },

  // 日期格式(YYYY-MM-DD)
  dateFormatter(element) {
    if (element) {
      return dayjs(element).format("YYYY-MM-DD");
    } else {
      return null;
    }
  },

  // 日期與時間格式(YYYY-MM-DD HH:mm)
  dateTimeFormatter(element) {
    if (element) {
      return dayjs(element).format("YYYY-MM-DD HH:mm");
    } else {
      return null;
    }
  },

  // 年月格式(YYYY-MM-DD)
  monthFormatter(element) {
    if (element) {
      return dayjs(element).format("YYYY-MM");
    } else {
      return null;
    }
  },

  // 取得 當日日期(YYYY-MM-DD)
  getToday() {
    return dayjs().format("YYYY-MM-DD");
  },

  // 取得 當前日期時間(YYYY-MM-DD HH:mm)
  getTime() {
    return dayjs().format("YYYY-MM-DD HH:mm");
  },

  // 取得 前一個禮拜的日期
  getLastWeek() {
    return dayjs().subtract(7, "day").format("YYYY-MM-DD");
  },

  // 取得 前一個月的日期(以當日為基準)
  getLastMonth() {
    return dayjs().subtract(1, "month").format("YYYY-MM-DD");
  },

  // 取得 三個月前日期(以當日為基準)
  getThreeMonthsAgo() {
    return dayjs().subtract(3, "month").format("YYYY-MM-DD");
  },
  
  // 移除自動填寫
  removeReadonly(event) {
    event.target.removeAttribute('readonly');
  },

  // 不可選擇小於今日的日期
  disabledDateBeforeToday(date) {
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    return date < today;
  },

  // 不可選擇大於今日的日期
  disabledDateAfterToday(date) {
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    return date > today;
  },

  // 不可選擇小於現在時間
  disabledTimeBeforeNowTime(time) {
    return time.getTime() < Date.now();
  },

  // 不可選擇大於現在時間
  disabledTimeAfterNowTime(time) {
    return time.getTime() > Date.now();
  },

  // 需求單狀態
  manpowerDemandStatusFormatter(status) {
    switch (status) {
      case "New":
        return "新建";
      case "Pending":
        return "待決";
      case "Approved":
        return "同意";
      case "Rejected":
        return "否決";
      case "Suspend":
        return "停用";
      case "Cancelled":
        return "作廢";
    }
  },

  // 金額千分位
  currencyThousands(num) {
    if (typeof num === "string") {
      const number = Number(num.replace(/,/g, ""));
      return number.toLocaleString("en-US");
    }
    return "0";
  },

  // 小數1位
  oneDecimalPlace(number) {
    // 提取第一個有效的數字（最多一位小數）
    const regex = /\d+(\.\d)?/;
    const match = regex.exec(String(number));
    let result = match ? parseFloat(match[0]) : 0;

    if (result <= 0) {
      return 0;
    }
    if (result > 999.9) {
      result = 999.9;
    }

    return result;
  },

  // 正整數
  positiveIntPlaces(number) {
    number = number.number.replace(/(^0+)|\D+/g, "");
    if (number <= 0) {
      number = "";
    }
    return number ?? 0;
  },

  // 是否 填寫同意書
  checkConsentForm() {
    api.resume
      .getConsentRecord({
        UserId: VueCookies.get("candidateId"),
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data) {
            // 有填寫過同意書
            router.push({ path: "/candidate/jobopening" });
          } else {
            // 沒有填寫過同意書
            router.push({ path: "/candidate/consentform" });
          }
        }
      });
  },

  // 下載 履歷 PDF
  downloadResumePDF(ResumeType, ResumeId) {
    store.dispatch("updateLoading", true);
    if (ResumeType === "IDL") {
      // IDL 履歷
      api.file.downloadIDLResumePDF(ResumeId).then((response) => {
        if (response.status === 200) {
          let fileName = decodeURIComponent(
            decodeURIComponent(
              response.headers["content-disposition"].split(
                "filename*=UTF-8''"
              )[1]
            )
          );
          store.dispatch("updateLoading", false);
          let blob = new Blob([response.data], { type: "application/pdf" });
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      });
    } else if (ResumeType === "DL") {
      // DL 履歷
      api.file.downloadDLResumePDF(ResumeId).then((response) => {
        if (response.status === 200) {
          let fileName = decodeURIComponent(
            decodeURIComponent(
              response.headers["content-disposition"].split(
                "filename*=UTF-8''"
              )[1]
            )
          );
          store.dispatch("updateLoading", false);
          let blob = new Blob([response.data], { type: "application/pdf" });
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      });
    } else {
      store.dispatch("updateLoading", false);
      Notification({
        title: "Error",
        message: "取得履歷類型失敗，請聯繫系統管理員。",
        type: "error",
        duration: 0,
      });
    }
  },

  // 下載 簡歷 PDF
  downloadSummaryPDF(ResumeId) {
    store.dispatch("updateLoading", true);
    api.file.downloadSummaryPDF(ResumeId).then((response) => {
      if (response.status === 200) {
        let fileName = decodeURIComponent(
          decodeURIComponent(
            response.headers["content-disposition"].split(
              "filename*=UTF-8''"
            )[1]
          )
        );
        store.dispatch("updateLoading", false);
        let blob = new Blob([response.data], { type: "application/pdf" });
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    });
  },

  // 下載 人事資料表 PDF
  downloadPersonnelInformationPDF(resumeType, matchId) {
    store.dispatch("updateLoading", true);
    if (resumeType === "IDL") {
      // IDL 人事資料表
      api.personnelInformation
        .downloadIDLPersonnelInformationPDF(matchId)
        .then((response) => {
          if (response.status === 200) {
            let fileName = decodeURIComponent(
              decodeURIComponent(
                response.headers["content-disposition"].split(
                  "filename*=UTF-8''"
                )[1]
              )
            );
            store.dispatch("updateLoading", false);
            let blob = new Blob([response.data], { type: "application/pdf" });
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
          }
        });
    } else if (resumeType === "DL") {
      // DL 人事資料表
      api.personnelInformation
        .downloadDLPersonnelInformationPDF(matchId)
        .then((response) => {
          if (response.status === 200) {
            let fileName = decodeURIComponent(
              decodeURIComponent(
                response.headers["content-disposition"].split(
                  "filename*=UTF-8''"
                )[1]
              )
            );
            store.dispatch("updateLoading", false);
            let blob = new Blob([response.data], { type: "application/pdf" });
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
          }
        });
    } else {
      store.dispatch("updateLoading", false);
      Notification({
        title: "Error",
        message: "取得履歷類型失敗，請聯繫系統管理員。",
        type: "error",
        duration: 0,
      });
    }
  },

  // 下載 檔案 by 檔案群組
  downloadFileGroup({ fileGuid, fileType }) {
    store.dispatch("updateLoading", true);
    api.file.downloadFileGroupFirstFile(fileGuid).then((response) => {
      if (response.status === 200) {
        let fileName = decodeURIComponent(
          decodeURIComponent(
            response.headers["content-disposition"].split(
              "filename*=UTF-8''"
            )[1]
          )
        );
        store.dispatch("updateLoading", false);
        let blob = new Blob([response.data], { type: fileType });
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    });
  },

  // 下載 檔案
  downloadFile({ fileGuid, fileType }) {
    store.dispatch("updateLoading", true);
    api.file.downloadFile(fileGuid).then((response) => {
      if (response.status === 200) {
        let fileName = decodeURIComponent(
          decodeURIComponent(
            response.headers["content-disposition"].split(
              "filename*=UTF-8''"
            )[1]
          )
        );
        store.dispatch("updateLoading", false);
        let blob = new Blob([response.data], { type: fileType });
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    });
  },

  // 下載 履歷範例檔(匯入資料按鈕)
  downloadResumeTemplate() {
    const resumeType = JSON.parse(
      localStorage.getItem("ResumeCard")
    ).ResumeType;
    store.dispatch("updateLoading", true);
    api.file.downloadResumeTemplate(resumeType).then((response) => {
      if (response.status === 200) {
        let fileName = decodeURIComponent(
          decodeURIComponent(
            response.headers["content-disposition"].split(
              "filename*=UTF-8''"
            )[1]
          )
        );
        store.dispatch("updateLoading", false);
        let blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    });
  },
};
